var React = require('react');

function Fork (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5 0c-.4 0-.8.3-.8.8V23c0 .6.4 1 1 1s1-.4 1-1v-8c0-.3.2-.5.5-.5H19c.7 0 1.2-.5 1.2-1.2C20.2 6.1 17.8 0 15.5 0zM10.8 0c-.6 0-1 .4-1 1v5c0 .5-.2 1-.6 1.4-.1.1-.3.1-.4 0 0 0-.1-.1-.1-.2V1c0-.6-.4-1-1-1s-1 .4-1 1v6.2c0 .1-.1.3-.3.2-.1 0-.1 0-.2-.1C6 7 5.7 6.5 5.8 6V1c0-.6-.4-1-1-1s-1 .4-1 1v5c0 1.7 1.1 3.2 2.7 3.8.2.1.3.3.3.5V23c0 .6.4 1 1 1s1-.4 1-1V10.2c0-.2.1-.4.3-.5 1.6-.6 2.7-2.1 2.7-3.8V1c0-.6-.5-1-1-1z"}));
}

Fork.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Fork;

Fork.default = Fork;
